import 'shared/styles/ScrollStyle.css'

import { useFormikContext } from 'formik'
import { ArrayList } from 'pop-up/components/arrayList'
import { InputWithPreName } from 'pop-up/components/InputWithPreName'
import { LeadSourceFormik } from 'pop-up/components/LeadSourceFormik'
import React, { useEffect } from 'react'
import ManagerApi from 'shared/api/manager/Api'
import FormikInput from 'shared/components/formik/Input'

import { formikValuesType } from '../..'

const inputClassName = 'w-[219px] h-[40px] rounded-lg '

export const ContactInfoForm = () => {
  const { values, setFieldValue } = useFormikContext<formikValuesType>()

  const fetchCustomerData = async () => {
    if (values?.lead?.id)
      return ManagerApi?.salesPersons
        ?.getClientDataDetail(values?.lead?.id)
        .then((res) => {
          return res.data
        })
    return null
  }

  useEffect(() => {
    if (values.lead?.id && values.lead.type === 'lead') {
      fetchCustomerData().then((res) => {
        if (!res) return
        const phoneNumbers =
          res.phoneNumbers?.filter((item) => item.startsWith('09')) || []
        const companyPhone =
          res.phoneNumbers?.filter((item) => !item.startsWith('09')) || []
        if (companyPhone.length) setFieldValue('companyPhone', companyPhone)
        if (phoneNumbers.length) setFieldValue('phoneNumbers', phoneNumbers)
        if (res.companyName) setFieldValue('companyName', res.companyName)
      })
    }
  }, [values?.lead?.id])

  return (
    <div
      className={
        'h-[615px] overflow-y-auto pr-[24px] w-full -translate-y-[40px]'
      }
      id={'scroll'}
      style={{ direction: 'ltr' }}
    >
      <div
        className={'flex  flex-col my-4 space-y-[36px]  w-full  '}
        style={{ direction: 'rtl' }}
      >
        {/*------------------------------------------*/}

        <div>
          <InputWithPreName
            label={'نام مشتری'}
            labelProps={{ variant: 'salesLabel', required: true }}
            preNameFieldName={'preName'}
            nameFieldName={'lead'}
            className={'!w-[219px] h-[40px] !outline-0 z-[10] '}
            selectClassName={'z-[10]'}
          />
        </div>

        {/*------------------------------------------*/}
        <LeadSourceFormik
          label={'نحوه آشنایی'}
          selectClassName={inputClassName + 'z-[5]'}
          name="leadSource"
          labelProps={{ variant: 'salesLabel', required: true }}
        />
        {/*------------------------------------------*/}
        <ArrayList
          label={'شماره موبایل'}
          name={'phoneNumbers'}
          inputClassName={inputClassName}
        />
        {/*------------------------------------------*/}
        <FormikInput
          label="نام شرکت"
          inputClassName={inputClassName}
          name="companyName"
          labelProps={{ variant: 'salesLabel', required: true }}
        />
        {/*------------------------------------------*/}
        <ArrayList
          label={'تلفن ثابت شرکت'}
          inputClassName={inputClassName}
          name="companyPhone"
        />
      </div>
    </div>
  )
}
